module.exports = __webpack_public_path__ + "img/check-on.a137fc7b.svg";